var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 131.233 131.233",
    height: 496,
    width: 496,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10016.2 16300v-625.9l376.2 313-376.2 312.9",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.10174 0 0 -.10174 -1017.944 1696.2)"
  })), /*#__PURE__*/React.createElement("path", {
    transform: "scale(.26458)",
    d: "M42.484 68.271c-18.899 0-34.732 13.852-37.834 31.907l191.211 159.031 31.909 26.498c10.817 9.027 28.56 9.027 39.376 0l33.504-27.82 189.655-157.71c-3.152-18.054-18.95-31.906-37.9-31.906ZM258.13 80.6c9.306.112 18.543 1.835 27.049 5.24 15.757 6.307 26.51 18.28 31.101 34.627h-.002c5.363 19.12 1.27 42.932-9.95 57.892-2.36 3.147-4.698 5.587-6.972 7.467-9.273 7.707-17.393 6.095-20.92 4.762-4.194-1.573-7.711-4.722-10.007-8.602-9.396 8.227-22.27 12.175-37.022 7.655-10.337-3.187-17.823-11.828-20.023-23.121-2.292-11.747 1.275-23.999 9.408-33.545a46.699 46.699 0 0 1 5.937-5.815c27.63-22.52 56.093-10.173 57.293-9.627l5.416 2.414-1.123 5.826c-1.377 7.16-4.34 23.055-6.2 34.495l.243.08c-.16.506-.315.999-.49 1.492-.679 4.253-1.172 7.76-1.332 9.734-.112 1.48 1.171 4.24 3.178 5 1.321.507 3.073-.027 5.02-1.414 1.762-1.266 3.688-3.227 5.605-5.787 7.265-9.693 12.18-28.213 7.512-44.853-3.327-11.867-10.813-20.199-22.235-24.772-18.27-7.28-40.734-4.974-57.252 5.893a56.169 56.169 0 0 0-11.242 9.787c-8.292 9.413-15.392 23.827-15.935 45.707-.654 25.973 12.158 38.612 23.023 44.638 16.559 9.187 39.708 8.535 55.047-1.572l8.24 12.52a58.98 58.98 0 0 1-6.008 3.453c-9.382 4.707-20.162 7.08-30.982 7.08-11.708 0-23.468-2.773-33.563-8.373-20.482-11.36-31.394-32-30.742-58.108.567-22.613 7.703-41.906 20.393-55.986a70.04 70.04 0 0 1 13.523-11.652C226.922 84.7 242.62 80.413 258.13 80.6zm5.523 48.054c-7.693 0-17.607 2.106-27.46 10.133a29.986 29.986 0 0 0-4.602 4.693c-4.699 5.96-6.822 13.374-5.498 20.174 1.14 5.867 4.688 10.106 9.724 11.653 9.027 2.8 16.11.68 21.385-3.387 4.903-3.773 8.243-9.212 10.113-13.96 1.52-9.426 3.687-21.186 5.038-28.413a42.305 42.305 0 0 0-8.7-.893z",
    style: {
      display: "inline",
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.38911429
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11282.1 15674.1v625.9l-376.3-312.9 376.3-313",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.10174 0 0 -.10174 -1017.944 1696.2)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      fill: "#000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m11017.4 16240.2-69-57.3c-28.8-23.9-76-23.9-104.8 0l-88.9 73.9-51.8 43.2-416-345.9c17.5-14.1 39.6-22.5 63.7-22.5h1090.8c24.1 0 46.3 8.4 63.8 22.5l-416.1 345.9-71.7-59.8",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.09943 0 0 -.09943 -1017.944 1696.2)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.8708e741108bb5e544a74bff38baa7ce.svg";
export { ForwardRef as ReactComponent };